import { render, staticRenderFns } from "./CreatePostButton.vue?vue&type=template&id=4319e5d7&scoped=true&"
import script from "./CreatePostButton.vue?vue&type=script&lang=ts&"
export * from "./CreatePostButton.vue?vue&type=script&lang=ts&"
import style0 from "./CreatePostButton.vue?vue&type=style&index=0&id=4319e5d7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4319e5d7",
  null
  
)

export default component.exports